<template>
	<div>
		<v-alert
			v-if="errormsg.length !== 0"
			type="error"
			border="top"
			colored-border
		>
			{{ errormsg }}
		</v-alert>
		<div v-if="errormsg.length === 0 && loading">
			<v-progress-linear
				indeterminate
				color="#EAEAEA"
				background-color="#DADADA"
				rounded
				width="100px"
				height="15px"
				style="margin: 5px"
			></v-progress-linear>

			<v-progress-linear
				indeterminate
				color="#EAEAEA"
				background-color="#DADADA"
				rounded
				width="100px"
				height="15px"
				style="margin: 5px"
			></v-progress-linear>
		</div>
		<div class="leave-summary" v-if="errormsg.length === 0 && !loading">
			<div class="leave-summary-content">
				<div class="leave-summary-content-item">
					<div>Available Leave</div>
					<div>{{ availableLeave }}</div>
				</div>
				<div class="leave-summary-content-item">
					<div>Upcoming Leave</div>
					<div>{{ upcomingLeave }}</div>
				</div>
			</div>
			<div :class="`leave-summary-button ${$vuetify.breakpoint.smAndDown ? 'font-size-xs':'font-size-defualt padding-btn-paid'}`">
				<div class="text-capitalize" @click="calculate_leave">Calculate Leave</div>
				<div class="text-capitalize" @click="new_leave">Request Leave</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { metaMixin } from "@/mixins/events/metaMixin";

const LEAVE_KEY = 'annual leave';

const TODAY = moment().format("YYYY-MM-DD");
const TOMORROW = moment().add(1, 'days').format("YYYY-MM-DD"); 
const YEAR_END = moment().endOf('year').format("YYYY-MM-DD");

export default {
	name: 'LeaveSummary',
	mixins: [ metaMixin ],
	data() {
		return {
			errormsg: '',
			available_data: null,
			upcoming_data: null,
			event_types: [],
			annual_leave_id: null
		}
	},
	computed: {
		...mapState(['user']),
		loading() {
			if (this.available_data && this.upcoming_data ) {
				return false;
			}
			return true;
		},
		availableLeave() {
			let duration_sum = 0;
			if (this.available_data) {
				duration_sum = this.available_data;
			}
			return this.format_duration_available(duration_sum);
		},
		upcomingLeave() {
			let duration_sum = 0;
			if (this.upcoming_data && this.upcoming_data.length !== 0) {
				this.upcoming_data.forEach(element => {

					if (this.event_types && this.event_types.length !== 0 && element.event_type.id === this.annual_leave_id && element.leave_approved) {
						duration_sum += element.duration;
					}
				});
			}
			return this.format_duration(duration_sum);
		},
	},
	watch: {
		user() {
			if (this.user !== null) {
				this.load();
			}
		},
		event_types() {
			if (this.event_types.length !== 0) {
				const id_element = this.event_types.filter(item => {
					const condition = item.desc.toLocaleLowerCase();
					return condition === LEAVE_KEY;
				});
				this.annual_leave_id = id_element[0].id;

				this._load_available(TODAY);
				this._load_upcoming(TOMORROW, YEAR_END);
			}
		}
	},
	created() {
		this.load();
		this.load_meta_data();
	},
	methods: {
		load() {
			if (this.user == null) {
				// not yet available, still loading...
				console.log("User not yet available...");
				return;
			} else if (this.user.addressbook == null) {
				this.errormsg = "Your user account is not linked to an employee record...";
				return;				
			}
		},

		_load_available(current_time) {
			const params = [];
			params.push("employee=" + this.user.addressbook.id);
			params.push('date='+ current_time);
			params.push("event_type=" + this.annual_leave_id);
			

			let url = "/api/leave/available";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;
					
					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status === 'OK') {
						this.available_data = data;
					} else {
						this.errormsg = reason;
					}
				})
				.catch((e) => {
					this.errormsg = e.message;
				});
		},
		_load_upcoming(start_time, end_time) {
			const params = [];
			params.push("employees=" + this.user.addressbook.id);
			params.push("event_types=" + [2,3,4,5,6]);
			params.push('start_date='+ start_time);
			params.push('end_date='+ end_time);

			let url = "/api/leave";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { data, status, reason} = val.data;
					if (status == "OK") {
						this.upcoming_data = data;
					} else {
						this.errormsg = reason;
					}				
				})
				.catch(err => {
					this.errormsg = err;
				})
				.finally(() => {
				});	
		},
		format_duration(minutes) {
			if (minutes == 0) {
				return '0h';
			}
			const duration_obj = this.event_types.filter(item => 
			{
				const condition = item.desc.toLocaleLowerCase();
				return condition === LEAVE_KEY;
			});
			const duration = duration_obj[0].duration === 0 ? 8: duration_obj[0].duration;

			const day = Math.floor(minutes / (60.0 * duration));
			const hours = Math.floor( (minutes - day * 60.0 * duration) / 60.0 );
			const mins = minutes - day * 60.0 * duration - hours * 60.0;

			let fmt = '';
			if (day > 0) {
				fmt += day + 'd';
				if (hours > 0) {
					fmt += ' ';
				}
			}

			if (hours > 0) {
				fmt += hours + 'h';
				if (mins > 0) {
					fmt += ' ';
				}
			}

			if (mins > 0) {
				fmt += mins + 'm';
			}

			return fmt;
		},
		format_duration_available(total) {
			const current_leave = total.current_leave;
			const mins_per_day = total.mins_per_day;

			if (current_leave === 0) {
				return '0h';
			}
			
			const current_leave_positive = Math.abs(current_leave);

			const curr_days = Math.floor(current_leave_positive / mins_per_day);
			const current_leave_temp = current_leave_positive - (curr_days * mins_per_day);
			const curr_hrs = Math.floor(current_leave_temp / 60);
			const curr_mins = current_leave_temp - (curr_hrs * 60);

			let fmt = '';
			if (curr_days > 0) {
				fmt = curr_days + 'd ';
			}
			if (curr_hrs > 0) {
				fmt = fmt + curr_hrs + 'h ';
			}
			if (curr_mins > 0) {
				fmt = fmt + curr_mins + 'm';
			}

			return current_leave < 0 ? `- ${fmt}` : fmt;
		},
		calculate_leave(){
			this.$router.push({name:"Leave Calculator"})	
		},
		new_leave() {
			this.$router.push({ name: "Edit Leave", params: { id:  0 }});
		},
	}
}
</script>
<style lang="scss" scoped>
.leave-summary {
	display: flex;
	flex-flow: column nowrap;
	justify-content: flex-start;
}
.leave-summary-content {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
  margin-bottom: 25px;
	padding: 0 12px;
	>:first-child {
		margin-right: 20px;
	}
}
.leave-summary-content-item {
	display: flex;
	flex-flow: column nowrap;
	justify-content: flex-start;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 18px;
	color: #192A3E;
	>:first-child {
		font-size: 12px;
		line-height: 12px;
		color: rgba(25, 42, 62, 0.5);
	}
}
.leave-summary-button {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	div {
		display: flex;
		flex-flow: row nowrap;
		justify-content: center;
		align-items: center;
		border: 1px solid #2196F3;
		border-radius: 4px;
		color: #2196F3;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		line-height: 36px;
		text-overflow: ellipsis;
    white-space: nowrap;
		&:hover {
			cursor: pointer;
			font-size: 16px;
			font-weight: 800;
		}
	}
	:nth-child(1) {
		width: 45%;
	}
	:nth-child(2) {
		width: 50%;
	}
}
.font-size-xs {
	font-size: 12px;
}
.font-size-defualt {
	font-size: 16px;
}
.padding-btn-paid {
	padding: 0 12px;
}
</style>